import { Row } from 'antd'
import { ArnaIcon } from 'assets/svgComponent'
import React from 'react'
import styles from './footer.module.scss'
export default function FooterComponent() {
  return (
    <div className={styles.div}>
      <p className='t5 white50'>تمام حقوق برای اینوستو محفوظ است. ©‏ 1403</p>
      {/* <Row align={"middle"}>

      <p className='t5 white50 me10'>طراحی و پیاده سازی: </p>
      <ArnaIcon className={'mb5'}/>
      </Row> */}
    </div>
  )
}
